<template>
    <Form ref="formCustom" :model="formCustom" :rules="ruleCustom" :label-width="80" @submit.native.prevent>
        <FormItem label="手机号码" prop="tel" style="text-align: left;">
            <div v-if="sta.mobileNum">
                {{sta.mobileNum.replace(sta.mobileNum.substring(3,7),'****')}}
            </div>
            <div v-else>
                <Input v-model="formCustom.tel" placeholder="请输入11位手机号码" @on-change="showtips=false"></Input>
            </div>
        </FormItem>
        <FormItem label="短信验证" prop="sms">
            <Row>
                <Col span="10"> <Input v-model="formCustom.sms" @on-change="showtips=false" placeholder="请输入验证码..." /></Col>
                <Col span="14"><Button style="float: right;margin-right: 20%;background:#F0F6FF;" type="text" @click="countDown" :disabled="!this.canClick">{{content}}</Button></Col>
            </Row>
        </FormItem>
        <FormItem>
            <!--      <Alert type="warning" show-icon :style="{display: showtips?'block':'none'}">
        <span slot="desc">{{this.errmsg}}</span>
      </Alert> -->
        </FormItem>
    </Form>
</template>
<script>
import { mapActions, mapGetters } from 'vuex'
import regJson from '../../api/security/reg.js'
let regJ = new regJson()
export default {
    name: 'GetPwd',
    data() {
        const validateTel = (rule, value, callback) => {
            if (value === '') {
                callback(new Error('请输入手机号码'));
            } else {
                if (this.checkPhone(value)) {
                    callback()
                } else {
                    callback(new Error('手机号码输入有误,请重新输入.'));
                }
            }
        };
        const validateSms = (rule, value, callback) => {
            if (value === '') {
                callback(new Error('请输入短信验证码'));
            } else {
                callback();
            }
        };

        return {
            formCustom: {
                tel: '',
                sms: '',
                smstypecode: 0,
            },
            ruleCustom: {
                tel: [
                    { validator: validateTel, trigger: 'blur' }
                ],
                sms: [
                    { validator: validateSms, trigger: 'blur' }
                ],
            },
            showtips: false,
            errmsg: '您所提交的信息有误,请重新输入',
            content: '发送验证码',
            totalTime: 60,
            canClick: true, //添加canClick
            isSend: false, //防止重复提交请求
        }
    },
    computed: {
        ...mapGetters(['sta'])
    },
    methods: {
        handleSubmit(name) {
            this.$refs[name].validate((valid) => {
                if (valid) {
                    this.showtips = false;
                    this.$emit('reset-wxtoken', this.formCustom);
                    //console.log(this.formCustom);
                } else {
                    //this.$Message.error('Fail!');
                    this.showtips = true;
                }
            })
        },
        handleReset(name) {
            this.$refs[name].resetFields();
            this.showtips = false;
        },
        checkPhone(phoneNum) {
            var phone = phoneNum;
            if (!(/^1[3|4|5|6|7|8|9]\d{9}$/.test(phone))) {
                //alert("手机号码有误，请重填");  
                return false;
            } else {
                return true;
            }
        },
        countDown() {
            this.formCustom.tel = this.sta.mobileNum?this.sta.mobileNum:this.formCustom.tel
            if (this.isSend) {
                return
            } else {
                this.isSend = true
                //this.formCustom.tel = this.sta.mobileNum
                this.formCustom.smstypecode = this.$Tools.getSMSFrom().SMS_CODE_TYPE_RESET_WXTOKEN
                regJ.reqSmsCode(this.formCustom.tel, this.formCustom.smstypecode).then(res => {
                    this.isSend = false
                    console.log(this.formCustom.tel)
                    console.log(res)
                    if (res.rtncode === 1) {
                        if (res.rltcode === 1) {
                            this.$Message.info('验证码已发送')
                            console.log('验证码已发送')

                        } else {
                            this.$Message.error(res.rltdesc);
                            return
                        }
                    } else {
                        this.$Message.error(res.rtndesc);
                        return
                    }

                    if (!this.canClick) return //改动的是这两行代码
                    this.canClick = false
                    this.content = this.totalTime + 's后重新发送'
                    let clock = window.setInterval(() => {
                        this.totalTime--
                        this.content = this.totalTime + 's后重新发送'
                        if (this.totalTime < 0) {
                            window.clearInterval(clock)
                            this.content = '发送验证码'
                            this.totalTime = 60
                            this.canClick = true //这里重新开启
                        }
                    }, 1000)

                })
            }
        }
    },

}
</script>
<style>
</style>